import en from "./locales/en";
import es from "./locales/es";

export { en, es };
